import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('SessionSvc', SessionSvc);

    SessionSvc.$inject = ['logger'];

    /**
     * Service gérant la session
     */

    /* @ngInject */
    function SessionSvc(logger) {
        var currentUser = null;

        var exports = {
            create: create,
            destroy: destroy,
            getCurrentUser: getCurrentUser
        };

        return exports;

        ////////////////
        function create(userJson) {
            currentUser = userJson;
            logger.log('Session created for user : ', currentUser);
            return currentUser;
        }

        function destroy() {
            currentUser = null;
        }

        function getCurrentUser() {
            return currentUser;
        }
    }
})();
